var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "enquiry" } },
    [
      _c("p", [
        _vm._v(
          "If you are unsure about any part of your order, send us your cart through this form and we will get in touch with you to help you make your purchase."
        ),
      ]),
      _c(
        "b-form-group",
        { attrs: { label: "Your Name:" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.enquiry.name,
              callback: function ($$v) {
                _vm.$set(_vm.enquiry, "name", $$v)
              },
              expression: "enquiry.name",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: "Your E-mail:" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.enquiry.email,
              callback: function ($$v) {
                _vm.$set(_vm.enquiry, "email", $$v)
              },
              expression: "enquiry.email",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: "Message:" } },
        [
          _c("b-form-textarea", {
            model: {
              value: _vm.enquiry.message,
              callback: function ($$v) {
                _vm.$set(_vm.enquiry, "message", $$v)
              },
              expression: "enquiry.message",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "b-button",
            { attrs: { variant: "success" }, on: { click: _vm.send } },
            [_vm._v("Send")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }